<template>
    <div class="notFound">
     Page 404 Not Found
    </div>
  </template>
  
  
  <script>
  export default {
    name: 'NotFound',
    components: {
    }
  }
  </script>
  
  